import { FormProvider, useForm } from 'react-hook-form';
import Modal from '@/components/modal/Modal.tsx';
import ModalHeader from '@/components/modal/ModalHeader.tsx';
import ModalContent from '@/components/modal/ModalContent.tsx';
import ModalFooter from '@/components/modal/ModalFooter.tsx';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import { debugZodResolver } from '@/lib/debugZodResolver.ts';
import {
  tagSchema,
  TagFormData,
  TagFormInput,
} from '@/features/dashboard/tags/schemas/tagSchema.ts';
import { tagMapper } from '@/features/dashboard/tags/types/TagWebDto.mapper.ts';
import { TagWebDto } from '@/features/dashboard/tags/types/TagWebDto.ts';
import useUpdateTag from '@/features/dashboard/tags/hooks/useUpdateTag.ts';
import TagForm from '@/features/dashboard/tags/components/TagForm.tsx';

const EditTagModal = ({
  tag,
  onClose,
}: {
  tag: TagWebDto;
  onClose: () => void;
}) => {
  const updateMutation = useUpdateTag();

  const methods = useForm<TagFormInput>({
    resolver: debugZodResolver(tagSchema),
    defaultValues: tagMapper.fromDtoToForm(tag),
  });

  const onSubmit = (data: TagFormData) => {
    if (!tag.id) return;
    updateMutation.mutate(
      { id: tag.id, dto: tagMapper.fromFormToDto(data, tag.id) },
      { onSuccess: () => onClose() },
    );
  };

  return (
    <Modal
      onClose={onClose}
      isDirty={methods.formState.isDirty}
      className="max-w-[520px]"
    >
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <ModalHeader title="Edytuj tag" onClose={onClose} />
          <ModalContent>
            <TagForm />
          </ModalContent>
          <ModalFooter>
            <ActionButton
              tone="ghost"
              size="sm"
              type="button"
              onClick={onClose}
            >
              Anuluj
            </ActionButton>
            <ActionButton
              tone="accent"
              size="sm"
              type="submit"
              isLoading={updateMutation.isPending}
            >
              Zapisz zmiany
            </ActionButton>
          </ModalFooter>
        </form>
      </FormProvider>
    </Modal>
  );
};

export default EditTagModal;
